import { ApplicationState } from "application/redux"
import { connect } from "react-redux"
import { fetchHistory } from './redux/actions'
import RfTuningDvbcHistory from "./rf-tuning-dvbc-history-component"

const mapStateToProps = (state: ApplicationState) => ({
  dvbc: state.devices.detail.general.shadow?.custom?.DVBC || [],
  dvbcHistory: state?.devices.detail.rfTuning.dvbc.dvbcHistory || {},
  frequencyLimits: state.devices.detail.rfTuning.status.frequencyLimits,
})

export default connect(mapStateToProps, {
  fetchHistory
})(RfTuningDvbcHistory)
